"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var HelpTips = function HelpTips(props, ref) {
  var _a = props.OverlayTriggerProps,
    overlayTriggerProps = _a === void 0 ? {} : _a,
    _b = props.PopOverProps,
    popOverProps = _b === void 0 ? {} : _b,
    className = props.className,
    _c = props.noIcon,
    noIcon = _c === void 0 ? false : _c,
    label = props.label,
    children = props.children,
    style = props.style,
    tips = props.tips,
    _d = props.ignorePopMaxWidth,
    ignorePopMaxWidth = _d === void 0 ? false : _d,
    _e = props.ignorePopPadding,
    ignorePopPadding = _e === void 0 ? false : _e,
    _f = props.popPlacement,
    popPlacement = _f === void 0 ? 'top' : _f,
    _g = props.show,
    show = _g === void 0 ? true : _g,
    _h = props.inline,
    inline = _h === void 0 ? true : _h,
    _j = props.valign,
    valign = _j === void 0 ? -3 : _j,
    icon = props.icon,
    onMouseOver = props.onMouseOver,
    onMouseOut = props.onMouseOut,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave;
  var tmpicon;
  var content;
  var triggerContent;
  if (!show) {
    return null;
  }
  var svghelp = icon || react_1["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    width: 16,
    height: 16,
    className: "odc-svg-help"
  }, react_1["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 108 1a7 7 0 000 14zm.5-5.5c0 .41-.336.744-.747.744A.753.753 0 017 9.494V9c0-.416.369-.681 1.116-1.221L8.5 7.5c.664-.487 1-.862 1-1.25 0-.355-.03-.704-.5-1.03-.234-.16-.618-.224-1-.22-.395.004-.787.08-1 .22-.445.293-.5.719-.5 1a.279.279 0 01-.28.28H5.202a.205.205 0 01-.205-.203c-.007-.605-.015-1.25.566-1.858.563-.59 1.377-.94 2.437-.94.897 0 1.553.261 2.12.722.559.45.88 1.144.88 2.029 0 1.074-.622 1.56-1.267 2.066-.078.06-.156.122-.233.184l-.116.094c-.693.559-.884.713-.884.906zm-.625 3a.75.75 0 100-1.5h-.25a.75.75 0 100 1.5h.25z",
    clipRule: "evenodd"
  }));
  if (noIcon === false) {
    tmpicon = react_1["default"].createElement("i", {
      className: (0, classnames_1["default"])('odc-help-tips cursor-pointer', {
        'ml-4': inline
      }, "align-".concat(valign), className),
      style: style,
      ref: ref,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, svghelp);
  }
  if (children) {
    triggerContent = children;
  } else {
    if (label) {
      content = typeof label === 'string' ? react_1["default"].createElement("span", {
        className: "help-tips-label"
      }, label) : label;
      triggerContent = tmpicon ? react_1["default"].createElement("span", {
        className: "help-tips-group"
      }, content, tmpicon) : content;
    } else {
      triggerContent = tmpicon;
    }
  }
  if (children && !tips) {
    return children;
  }
  var popProps = popOverProps;
  if (ignorePopMaxWidth || ignorePopPadding) {
    popProps.className = (0, classnames_1["default"])({
      'no-max-width': ignorePopMaxWidth,
      'no-padding': ignorePopPadding
    }, popOverProps.className);
  }
  return react_1["default"].createElement(spaui_1.OverlayTrigger, __assign({
    trigger: "hover",
    overlay: react_1["default"].createElement(spaui_1.PopOver, __assign({
      gap: 4
    }, popProps), tips),
    placement: popPlacement,
    disabled: !tips
  }, overlayTriggerProps), triggerContent, typeof children === 'undefined' || !children ? icon : null);
};
(0, spaui_utils_1.setComponentMark)(HelpTips, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(HelpTips));